var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-fingerprint-pattern-icon lucide-fingerprint-pattern",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.12c0 2.38 0 6.38-1 8.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.29 21.02c.12-.6.43-2.3.5-3.02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a10 10 0 0 1 18-6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 16c.2-2 .131-5.354 0-6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65 22c.21-.66.45-1.32.57-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.8a6 6 0 0 1 9 5.2v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecur);
export default __webpack_public_path__ + "static/media/secur.0f04d98d48537b906ee59f1d27c07a2b.svg";
export { ForwardRef as ReactComponent };